import React, { useEffect, useState } from 'react'
import {
  Button,
  DialogActions,
  DialogContent,
  makeStyles
} from '@material-ui/core'
import {
  BASE_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from '../../asterX-UI'
import FieldInfoNG from '../../asterX-UI/DataDisplay/FieldInfoNG'
import {
  DISCOUNT_REASON,
  getExtraOptionsName
} from '../../constants/discountTypes'
import { useAuthStore } from 'context/AuthStore'
import { useWorkListViewRopStore } from '../../context/WorkListViewStore/Rop/WorkListViewStore.rop'
import { CarService } from '../../lib/api'
import { useResErrors } from '../../hooks'
import CarSelectionCard from '../Mobile/Car/CarSelectionCard'
import { ChevronRight } from '@material-ui/icons'
import { Modal, ModalTitle } from 'asterX-UI/Modals'
import Lightbox from 'react-18-image-lightbox'
import OrdersModal from 'components/Desktop/Car/OrdersModal'
import CarTechStateModal from 'components/CarTechStateModal/CarTechStateModal'

const useStyles = makeStyles(theme => ({
  wrapper: {
    border: '1px solid ' + WARNING_COLORS[400],
    borderRadius: 12,
    backgroundColor: BASE_COLORS.White,
    display: 'flex',
    width: '100%',
    padding: 16,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    '@media (max-width: 600px)': {
      flexDirection: 'column'
    }
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: GRAY_COLORS[800]
  },
  btnDiscount: {
    display: 'flex',
    gap: 5,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 14,
    color: PRIMARY_COLORS[700],
    alignItems: 'center',
    '&:hover': {
      color: PRIMARY_COLORS[900]
    }
  },
  sceleton: {
    width: '100%',
    height: 200,
    backgroundColor: GRAY_COLORS[300],
    animation: '$pulse 1.5s infinite',
    borderRadius: 12
  },
  '@keyframes pulse': {
    '0%': {
      opacity: 0.5
    },
    '50%': {
      opacity: 1
    },
    '100%': {
      opacity: 0.5
    }
  },
  wrapperModal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16,
    width: 450,
    '@media (max-width: 600px)': {
      width: '100%'
    }
  }
}))

const DiscountRequest = ({ car, tradeInCarVin }) => {
  const classes = useStyles()

  const [open, setOpen] = useState(false)
  const [tradeInCar, setTradeInCar] = useState(null)
  const { standardCheck } = useResErrors()
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (tradeInCarVin) {
      getCarByVin()
    }
  }, [tradeInCarVin])

  const getCarByVin = async () => {
    setIsLoading(true)

    await CarService.getCarByVin(tradeInCarVin).then(response =>
      standardCheck(response, () => {
        setTradeInCar(response.data)
      })
    )

    setIsLoading(false)
  }

  return isLoading ? (
    <div className={classes.sceleton}></div>
  ) : (
    <div className={classes.wrapper}>
      <div
        className={classes.row}
        style={{
          justifyContent: 'space-between'
        }}
      >
        <div className={classes.title}>Запрос на скидку</div>
        <div className={classes.btnDiscount} onClick={() => setOpen(true)}>
          Подробнее <ChevronRight />
        </div>
      </div>
      <DiscountContent car={car} tradeInCar={tradeInCar} />
      <ModalR
        car={car}
        open={open}
        onClose={() => setOpen(false)}
        tradeInCar={tradeInCar}
      />
    </div>
  )
}

export default DiscountRequest

const DiscountContent = ({ car, tradeInCar }) => {
  const classes = useStyles()
  const discountPercent = ((car?.discountAmount || 0) / car?.price) * 100
  return (
    <>
      <div
        className={classes.row}
        style={{
          justifyContent: 'flex-start',
          gap: 10
        }}
      >
        <FieldInfoNG
          label={'Сумма скидки'}
          isVertical
          style={{
            borderRadius: 4,
            backgroundColor: WARNING_COLORS[300],
            color: GRAY_COLORS[700],
            fontWeight: 500,
            fontSize: 14,
            paddingLeft: 5,
            paddingRight: 5
          }}
        >
          {car?.discountAmount?.toString()?.thousandSeparator() || 0} ₸ (
          {discountPercent.toFixed(2)}%)
        </FieldInfoNG>
        <FieldInfoNG
          label={'Причина скидки'}
          isVertical
          style={{
            fontSize: 14,
            fontWeight: 400
          }}
        >
          {DISCOUNT_REASON[car?.discountReason] || 'Данные отсутствуют'}
        </FieldInfoNG>

        {car?.marginReason && (
          <FieldInfoNG
            label={'Причина наценки'}
            isVertical
            style={{
              fontSize: 14,
              fontWeight: 400
            }}
          >
            {getExtraOptionsName(car?.marginReason) || 'Данные отсутствуют'}
          </FieldInfoNG>
        )}
      </div>
      <div
        className={classes.row}
        style={{
          justifyContent: 'flex-start',
          gap: 10
        }}
      >
        <FieldInfoNG
          label={'Сумма наценки'}
          isVertical
          style={{
            color: GRAY_COLORS[700],
            fontWeight: 500,
            fontSize: 14
          }}
        >
          {car?.discountMargin?.toString()?.thousandSeparator() || 0} ₸
        </FieldInfoNG>
        <FieldInfoNG
          label={'Цена со скидкой'}
          isVertical
          style={{
            color: GRAY_COLORS[700],
            fontWeight: 500,
            fontSize: 14
          }}
        >
          {car?.discountValue?.toString()?.thousandSeparator() || 0} ₸
        </FieldInfoNG>
        <FieldInfoNG
          label={'Цена без скидки'}
          isVertical
          style={{
            color: GRAY_COLORS[700],
            fontWeight: 500,
            fontSize: 14
          }}
        >
          {car?.price?.toString()?.thousandSeparator() || 0} ₸
        </FieldInfoNG>
      </div>
      {car?.discountApproveRopFullName && (
        <div
          className={classes.row}
          style={{
            justifyContent: 'flex-start',
            gap: 10
          }}
        >
          <FieldInfoNG
            label={'Скидка согласована'}
            isVertical
            style={{
              color: GRAY_COLORS[700],
              fontWeight: 500,
              fontSize: 14
            }}
          >
            {car?.discountApproveRopFullName || 'Данные отсутствуют'}
          </FieldInfoNG>
        </div>
      )}

      <div className={classes.row}>
        {tradeInCar && <CarSelectionCard car={tradeInCar} onClick={() => {}} />}
      </div>
    </>
  )
}

const ModalR = ({ car, open, onClose, tradeInCar = null }) => {
  const { authStore } = useAuthStore()
  const {
    store: { loading },
    actions: { handleApproveDiscount }
  } = useWorkListViewRopStore()
  const [isOrdersModalOpen, setIsOrdersModalOpen] = useState(false)
  const [techState, setTechState] = useState(false)

  const [photoIndex, setPhotoIndex] = useState(null)
  const classes = useStyles()
  const discountPhotos = car?.discountPhotos
  return (
    <Modal open={open} onClose={onClose} maxWidth={'md'}>
      <ModalTitle onClose={onClose}>
        Запрос на скидку
        <span
          style={{
            fontSize: 12,
            color: GRAY_COLORS[500]
          }}
        >
          {car?.vin}
        </span>
      </ModalTitle>
      <DialogContent>
        <div className={classes.wrapperModal}>
          <DiscountContent car={car} tradeInCar={tradeInCar} />
          <div
            className={classes.row}
            style={{
              justifyContent: 'space-between',
              gap: 10
            }}
          >
            {discountPhotos?.length > 0 && (
              <Button
                variant={'outlined'}
                fullWidth
                size={'small'}
                onClick={() => setPhotoIndex(0)}
              >
                Документ ({discountPhotos?.length || 0})
              </Button>
            )}
            <Button
              variant={'outlined'}
              fullWidth
              size={'small'}
              onClick={() => setTechState(true)}
            >
              Тех состояние
            </Button>
            <Button
              variant={'outlined'}
              fullWidth
              size={'small'}
              onClick={() => setIsOrdersModalOpen(true)}
            >
              Заказ-наряды
            </Button>
          </div>
        </div>
      </DialogContent>
      {authStore.user.role !== 'SPP' &&
        car.discountReason !== 'BONUS' &&
        !car?.discountApproveRopFullName && (
          <DialogActions>
            <Button
              disabled={loading}
              variant={'contained'}
              color={'secondary'}
              fullWidth
              onClick={() => handleApproveDiscount(false)}
            >
              Отказать
            </Button>
            <Button
              variant={'contained'}
              fullWidth
              disabled={loading}
              style={{
                backgroundColor: SUCCESS_COLORS[700],
                color: BASE_COLORS.White
              }}
              onClick={() => handleApproveDiscount(true)}
            >
              Согласовать
            </Button>
          </DialogActions>
        )}
      <Modal open={isOrdersModalOpen} fullScreen>
        <OrdersModal
          onClose={() => setIsOrdersModalOpen(false)}
          vin={car?.vin}
        />
      </Modal>
      <CarTechStateModal
        open={techState}
        vin={car?.vin}
        onClose={() => setTechState(false)}
      />
      {photoIndex !== null && discountPhotos?.length > 0 && (
        <Lightbox
          reactModalStyle={{
            content: { zIndex: 1400 },
            overlay: { zIndex: 1400 }
          }}
          mainSrc={discountPhotos[photoIndex]}
          nextSrc={discountPhotos[(photoIndex + 1) % discountPhotos.length]}
          prevSrc={
            discountPhotos[
              (photoIndex + discountPhotos.length - 1) % discountPhotos.length
            ]
          }
          onCloseRequest={() => setPhotoIndex(null)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + discountPhotos.length - 1) % discountPhotos.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % discountPhotos.length)
          }
        />
      )}
    </Modal>
  )
}
